import { render } from "./SkuInfo.vue?vue&type=template&id=75952036&scoped=true&ts=true"
import script from "./SkuInfo.vue?vue&type=script&lang=ts"
export * from "./SkuInfo.vue?vue&type=script&lang=ts"

import "./SkuInfo.vue?vue&type=style&index=0&id=75952036&lang=less&scoped=true"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75952036"]])

export default __exports__